import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    date: {
      fontWeight: 'bold'
    },
    headerText: {
      fontSize: '1.5rem',
      fontWeight: 'bold'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
